var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    d: "M5.147 5.146a.5.5 0 0 1 .707 0l2.13 2.131 2.131-2.13a.5.5 0 0 1 .638-.058l.07.057a.5.5 0 0 1 0 .708L8.69 7.984l2.132 2.131a.5.5 0 0 1 .058.638l-.058.07a.5.5 0 0 1-.707 0L7.984 8.69l-2.13 2.133a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.131-2.131-2.13-2.13a.5.5 0 0 1-.058-.638z"
  })));
};
export default SvgX;